export enum ComponentSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  Default = Medium,
}
